




























































import { Component, Prop, Vue } from 'vue-property-decorator'
import { Action } from '@/api/model/action'
import { ActionType } from '@/api/types'
import { User } from '@/api/model/user'
import { isDoneTask, isOverdueTask } from '@/helpers/overdue-actions'

@Component
export default class CalendarAction extends Vue {
    @Prop({ required: true }) action!: Action
    @Prop({ required: true }) view!: string

    /** Done tasks get a tick and grey; appointments are never "done" here */
    get done(): boolean {
        return isDoneTask(this.action)
    }

    /** The same rule as the dashboard's "Achterstallig": open, before today, lead not won or lost */
    get overdue(): boolean {
        return isOverdueTask(this.action)
    }

    colorForAction(action: Action): string {
        if (action.type === ActionType.MEETING) {
            return 'purple'
        }

        if (this.overdue) {
            return 'red'
        }

        if (this.done) {
            return 'gray'
        }

        return 'blue'
    }

    classesForAction(action: Action): string[] {
        // White with a border: grey on grey would vanish in the off-hours cells (bg-gray-100)
        if (this.done) {
            return ['bg-white', 'border', 'border-gray-300']
        }

        return [
            `bg-${this.colorForAction(action)}-100`,
        ]
    }

    iconForAction(action: Action): string {
        if (action.type === ActionType.MEETING) {
            // Determine icon based on appointment type
            switch (action.appointmentType) {
                case 'video': return 'icon-meeting-action-video'
                case 'phone': return 'icon-phone-retro'
                case 'office': return 'icon-meeting-action-office'
                case 'customer': return 'icon-meeting-action-customer'
                default: return 'icon-meeting-action'
            }
        } else {
            // Determine icon based on type
            switch (action.type) {
                // case 'meeting': return 'icon-meeting-action'
                case 'email': return 'icon-email-action'
                case 'call': return 'icon-call-action'
                case 'reminder': return 'icon-reminder-action'
                case 'letter': return 'icon-letter-action'
                case 'billing': return 'icon-billing'
                case 'update': return 'icon-update-action'
                case 'notification': return 'icon-reminder-action'
                default: return 'icon-task-action'
            }
        }
    }

    iconClassesForAction(action: Action): string[] {
        return [
            `bg-white`,
            `text-${this.colorForAction(action)}-600`,
        ]
    }

    classesForUser(action: Action, user: User) {
        if (user.id === this.$currentUser.id) {
            return [
                `text-${this.colorForAction(action)}-600`,
                `font-bold`,
            ]
        }

        return []
    }
}
